<template>
  <el-form ref="formData" label-width="150px" :model="formData" :disabled="true">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item
          label="整改要求"
          prop="hiddenDangerOpinionsRectification"
          ref="hiddenDangerOpinionsRectification"
        >
          <el-input
            type="textarea"
            v-model="formData.hiddenDangerOpinionsRectification"
            clearable
            :disabled="formProps.editType === 'read'"
          ></el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item label="方案负责人" prop="solutionLeaderUserId">
          <MultiplePersonSelect
            class="w-full"
            placeholder="请输入方案负责人"
            v-model="formData.solutionLeaderUserId"
            :disabled="formProps.editType === 'read'"
          ></MultiplePersonSelect>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item label="开始整改时间" prop="startRectificationTime">
          <el-date-picker
            size="small"
            v-model="formData.startRectificationTime"
            :disabled="formProps.editType === 'read'"
            type="datetime"
            class="!w-full"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item
          label="整改后图片"
          prop="photosAfterRectification"
          ref="photosAfterRectification"
        >
          <img-upload
            v-model="formData.photosAfterRectification"
            :upload-width="120"
            :upload-height="120"
            :maxSize="20"
            :limit="5"
            :isDisabledUploadComponent="true"
            :isShowDeleteButton="false"
          ></img-upload>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="隐患解决方案"
          prop="hiddenHazardRectificationPlan"
          ref="hiddenHazardRectificationPlan"
        >
          <el-input
            v-model="formData.hiddenHazardRectificationPlan"
            placeholder="请输入隐患解决方案"
            maxlength="500"
            :show-word-limit="true"
            type="textarea"
            :rows="4"
            clearable
            :disabled="formProps.editType === 'read'"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-form-item
          label="附件"
          prop="hiddenHazardRectificationAttachments"
          ref="hiddenHazardRectificationAttachments"
        >
          <form-upload
            :disabled="formProps.editType === 'read'"
            :maxSize="200"
            :limit="1"
            :accept="['jpg', 'jpeg', 'png', 'gif', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt']"
            v-model="formData.hiddenHazardRectificationAttachments"
          ></form-upload>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'

import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import MultiplePersonSelect from '@/components/safety/PersonSelect/MultiplePersonSelect'

const areaApi = new AreaApi()

export default {
  name: 'hidden-rectification-view',
  components: {
    ImgUpload,
    MultiplePersonSelect,
    FormUpload,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'read',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo'],
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
  },
  computed: {},
  created() {
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
      ],
      ['hiddenLevelList', 'hiddenTypeList', 'hiddenCategoryList'],
      this
    )
  },
  mounted() {},

  methods: {
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
